import { render } from "./CollectionProductTh.vue?vue&type=template&id=0b83835c"
import script from "./CollectionProductTh.vue?vue&type=script&lang=js"
export * from "./CollectionProductTh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__